export const REVIEW_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Retain',
  REJECTED: 'Revoke',
};

export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200];
export const DEFAULT_PAGE_SIZE = 100;
